import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO62 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK006-2.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO62
